export const validateAndProcessProduct = (produto: string, _numero: string): string => {
  if (!produto || produto === 'Produto não informado' || produto.trim() === '') {
    return 'ERRO_PRODUTO_NAO_EXTRAIDO';
  }
  return produto;
};

export const logProductValidation = (_produto: string, _numero: string, _apiData: any): void => {
  // Silenced during bulk sync
};

export const validateFinalProduct = (_produtoFinal: string | null, _numero: string): void => {
  // Silenced during bulk sync
};

export const logFinalProductResult = (_ordemServico: any, _apiData: any, _empresaIdFinal: string): void => {
  // Silenced during bulk sync
};
